export default __webpack_public_path__ + "static/media/ic_password_view.52467959.svg";